import React, { useState } from "react";
////import { Identity } from "../../components/Identity";
import { PageTopbar } from "../../../components/Page/Topbar";
import { PageHeader } from "../../../components/Page/Header";
import { AppManagementOverviewsDepot } from "../../../app/Management/Overviews/Depot";

export function RoutesManagementOverviewsDepot({ title, parents, current }) {

    let identifier = (parents + current).replaceAll('/', '-');
    const [refresh, setRefresh] = useState(false);
    const [filterFields, setFilterFields] = useState([]);
    const [filterValues, setFilterValues] = useState(JSON.parse(localStorage.getItem("filters" + identifier)) ?? {});

    const resetFilterValues = (values) => {
        setFilterValues(values);
        setRefresh(refresh === false);
    }

    return (
        <div>
            <PageTopbar
                parents={parents}
                current={current}
            />

            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                identifier={identifier}
                filterFields={filterFields}
                setFilterValues={resetFilterValues}
            />

            <AppManagementOverviewsDepot
                current={current}
                identifier={identifier}
                filterValues={filterValues}
                setFilterFields={setFilterFields}
            />
        </div>
    );
}